"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _classnames4 = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var _Button = _interopRequireWildcard(require("../../../../../../../ui/Button"));
var _EditableContentControl = require("../../../../../../../ui/EditableContentControl");
var _actions = require("../../../../../../store/actions");
var _selectors = require("../../../../../../store/selectors");
var _comment = _interopRequireDefault(require("./img/comment.svg"));
var _plus = _interopRequireDefault(require("./img/plus.svg"));
var _styles = _interopRequireDefault(require("./styles"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var HoveredText = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    :hover {\n        color: ", ";\n    }\n"])), function (props) {
  return props.theme.primaryColor;
});
var Comment = function Comment(_ref) {
  var basketID = _ref.basketID,
    isMobile = _ref.isMobile,
    offerID = _ref.offerID;
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useTranslation = (0, _reactI18next.useTranslation)('BASKET_EDIT_FORM'),
    t = _useTranslation.t;
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return (0, _selectors.getOfferExtra)(state, {
        basketID: basketID,
        offerID: offerID
      });
    }),
    initialComment = _useSelector.comment;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    editMode = _useState2[0],
    setEditMode = _useState2[1];
  var onChangeFinally = function onChangeFinally(comment) {
    dispatch((0, _actions.updateOfferInBasket)(offerID, basketID, {
      comment: comment
    }));
    setEditMode(false);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames4.default)(_styles.default.commentContainer, _defineProperty({}, _styles.default.isMobile, isMobile))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames4.default)(_styles.default.commentBody, _defineProperty({}, _styles.default.editableBody, editMode))
  }, editMode ? /*#__PURE__*/_react.default.createElement(_EditableContentControl.EditableContentControl, {
    className: _styles.default.editWrapper,
    value: initialComment,
    onClose: function onClose() {
      return setEditMode(false);
    },
    onConfirm: onChangeFinally
  }) : /*#__PURE__*/_react.default.createElement(_Button.default, {
    activeIcon: true,
    className: (0, _classnames4.default)(_styles.default.button, _defineProperty({}, _styles.default.initialComment, initialComment)),
    contentClassName: _styles.default.placeholder,
    height: _Button.HEIGHTS.FLUID,
    width: _Button.WIDTHS.FLUID,
    fontFamily: _Button.FONT_FAMILIES.REGULAR,
    icon: initialComment ? _comment.default : _plus.default,
    iconClassName: _styles.default.icon,
    size: _Button.SIZES.TINY,
    theme: _Button.THEMES.TRANSPARENT,
    onClick: function onClick() {
      return setEditMode(true);
    }
  }, /*#__PURE__*/_react.default.createElement(HoveredText, null, initialComment || t('COMMENT_PLACEHOLDER')))));
};
Comment.propTypes = {
  basketID: _propTypes.default.number.isRequired,
  offerID: _propTypes.default.string.isRequired,
  isMobile: _propTypes.default.bool
};
var _default = exports.default = (0, _react.memo)(Comment);